import axios from 'axios';
import {useQuery, useQueryClient} from 'react-query';
import {environment} from '../config/environment';

import {latestBlockState} from '../state';
import {useSetRecoilState} from "recoil";


export const useSummary = (options?: any) => {
    const setLatestBlockState= useSetRecoilState(latestBlockState)
    const queryClient = useQueryClient();
    return useQuery(
        'summary',
        () => axios.get(`${environment.apiBase}/summary`).then((res) => res.data),
        {
            // refetchInterval:20 * 1000,
            // refetchIntervalInBackground:true,
            staleTime: 30 * 1000,
            onSuccess: (res: any) => {
                setLatestBlockState({
                    height:res.payload.latestBlockHeight,
                    hash:res.payload.latestBlockHash,
                });
                queryClient.refetchQueries({queryKey:'latest-blocks'})
                queryClient.refetchQueries({queryKey:'latest-txs'})
            },
            ...options,
        }
    );
};

export default useSummary;
